import userService from 'services/user'
import { setUser } from 'actions/sync'

export function fetchUser() {
  return (dispatch) => {
    return userService.fetchUser().then((response) => {
      dispatch(setUser(response.data))
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/actions/async/user.js